import { render, staticRenderFns } from "./SkippingReport.vue?vue&type=template&id=124dcbf2&scoped=true"
import script from "./SkippingReport.vue?vue&type=script&lang=js"
export * from "./SkippingReport.vue?vue&type=script&lang=js"
import style0 from "./SkippingReport.vue?vue&type=style&index=0&id=124dcbf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124dcbf2",
  null
  
)

export default component.exports